import {
    getMeteringRecord,
    listMeteringRecords,
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {MeteringRecord} from "../types.ts";
import {billingApiClient} from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";

export type ListMeteringRecords = {
    listMeteringRecords: { items: MeteringRecord[], nextToken: string }
}

export type GetMeteringRecord = {
    getMeteringRecord: MeteringRecord
}


const client = billingApiClient;

const normalizeFilter = (filter: { [key: string]: string }) =>
    Object.keys(filter).reduce((acc: { [key: string]: string }, key) => {
        if (filter[key] !== '' && filter[key] !== undefined) {
            acc[key] = filter[key];
        }
        return acc;
    }, {});

// FNP-534 / FNP-538: MeteringRecords are read-only and backed by a SINGLE list
// operation. MeteringRecordsFilterInput supports { customerId, meterId, meterCode,
// state, periodStartFrom, periodStartTo }. fetchRecords forwards whatever subset is
// active; the backend resolver (FNP-538) routes meterId + a periodStart bound to a
// key-range Query on meter-period-index (a real server-side narrowing of the
// token-paginated list), and applies the rest as non-key filters. Nothing is faked
// client-side — a client filter would only narrow the loaded page and hide later
// matches.
export const fetchRecords = async (query: ListRecordsQuery) => {
    const {filter, limit, nextToken} = query;
    const normalized = filter ? normalizeFilter(filter as { [key: string]: string }) : {};

    const response = await client.graphql<GraphQLQuery<ListMeteringRecords>>({
        query: listMeteringRecords,
        variables: {
            ...(Object.keys(normalized).length ? {filter: normalized} : {}),
            ...(query.sort ? {sort: query.sort} : {}),
            limit,
            nextToken,
        },
    });
    return {
        items: response.data?.listMeteringRecords.items,
        nextToken: response.data?.listMeteringRecords.nextToken,
    };
};

// MeteringRecord has a two-part key (customerId PK + sortKey SK); the detail page
// supplies both. There is no single-id get.
export const fetch = async (customerId: string, sortKey: string) => {
    const response = await client.graphql<GraphQLQuery<GetMeteringRecord>>({
        query: getMeteringRecord,
        variables: {customerId, sortKey},
    });
    return response.data?.getMeteringRecord;
};
